module.exports = __webpack_public_path__ + "static/confidence-cae16e99ee6078ac7349bb7ab6ddad57.png";